import Avatar from 'common/Avatar/Avatar'
import { useUserCard } from 'hooks/queries/users/useUserCard'
import { useAuth } from 'hooks/UseAuth'
import Styles from './CollabItemInlineTooltip.module.scss'

import { CollabItemInlineTooltipProps } from './Types'

const Placeholder = () => (
  <div className={Styles.tooltip}>
    <Avatar size={24} backgroundColor={Styles.grey5} />
    <span className={Styles.namePlaceholder} />
  </div>
)

const CollabItemInlineTooltip = ({ userId, content }: CollabItemInlineTooltipProps) => {
  const auth = useAuth()
  const userQuery = useUserCard(userId, {
    // 1 day
    staleTime: 24 * 60 * 60 * 1000,
    refetchOnMount: false,
  })

  const user = userQuery.data?.user
  if (!user) {
    return <Placeholder />
  }

  const userName = user.id === auth?.id ? 'You' : user.display_name || ''
  const displayText = content || userName

  return (
    <div className={Styles.tooltip}>
      <Avatar url={user.avatar_url} label={userName} size={24} />
      <span className={Styles.displayText}>{displayText}</span>
    </div>
  )
}

export { CollabItemInlineTooltip }
